import { render, staticRenderFns } from "./insMotionData.vue?vue&type=template&id=5a1bcbfc&"
import script from "./insMotionData.vue?vue&type=script&lang=js&"
export * from "./insMotionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports